import { EMPTY_STATE } from "./chartState";

export function completedWorkAutoMarksMissing(item) {
  return item?.auto_marks_missing === true || item?.is_extraction === true;
}

export function buildCompletedWorkByTooth(completedWorkItems) {
  const byTooth = {};
  for (const item of completedWorkItems ?? []) {
    if (completedWorkAutoMarksMissing(item)) continue;
    const teeth = Array.isArray(item?.tooth_numbers)
      ? item.tooth_numbers.map(String).filter(Boolean)
      : [];
    for (const tooth of teeth) {
      if (!byTooth[tooth]) byTooth[tooth] = [];
      byTooth[tooth].push(item);
    }
  }
  for (const tooth of Object.keys(byTooth)) {
    byTooth[tooth].sort((a, b) => {
      const aTime = a.completed_at ? new Date(a.completed_at).getTime() : 0;
      const bTime = b.completed_at ? new Date(b.completed_at).getTime() : 0;
      return bTime - aTime;
    });
  }
  return byTooth;
}

export function applyCompletedWorkChartEffects(state, completedWorkItems) {
  const missingItems = (completedWorkItems ?? []).filter(completedWorkAutoMarksMissing);
  if (missingItems.length === 0) return state ?? EMPTY_STATE;

  const next = {
    version: state?.version ?? 1,
    teeth: { ...(state?.teeth ?? {}) },
    bridges: Array.isArray(state?.bridges) ? [...state.bridges] : [],
  };

  for (const item of missingItems) {
    const teeth = Array.isArray(item?.tooth_numbers)
      ? item.tooth_numbers.map(String).filter(Boolean)
      : [];
    for (const tooth of teeth) {
      markToothMissingFromCompletedWork(next, tooth, item);
    }
  }

  return next;
}

function markToothMissingFromCompletedWork(state, tooth, item) {
  const current = state.teeth[tooth] ?? { findings: [] };
  const existingFindings = Array.isArray(current.findings) ? current.findings : [];
  const preservedFindings = existingFindings.filter(preserveFindingAfterMissing);
  const missingFinding = {
    finding_code: "missing",
    surfaces: [],
    locked: true,
    source: "completed_work_auto_missing",
    auto_marked_by_completed_work_id: item.id ?? null,
    source_table: item.source_table ?? null,
    source_id: item.source_id ?? null,
    procedure_name: item.procedure_name ?? null,
    completed_at: item.completed_at ?? null,
  };

  state.teeth[tooth] = {
    ...current,
    findings: [...preservedFindings, missingFinding],
  };
}

function preserveFindingAfterMissing(finding) {
  if (!finding?.finding_code) return false;
  if (finding.finding_code === "missing") return false;
  if (finding.finding_code === "to_extract" || finding.finding_code === "watch") return false;
  if (finding.finding_code === "note") return true;
  return !Array.isArray(finding.surfaces) || finding.surfaces.length === 0;
}
